import { MemoryPage } from "@/components/memory/memory-page.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute("/_authenticated/settings/memory")({
	component: MemoryPage,
	pendingComponent: RoutePending,
	head: () => ({
		meta: [{ title: pageTitle(m.memory_title()) }],
	}),
});
